import getWindow from '@loggi/js/get-window';

const $window = getWindow();

function push(event, variables = {}) {
  if (!$window.dataLayer) {
    return null;
  }

  $window.dataLayer.push({
    event,
    ...variables
  });
}

export default {
  push
};
